import { Link } from 'react-router-dom'
import { IconClockPlus } from '@tabler/icons-react'
import { HeyDrive } from '@/models/drive.ts'
import { useProfile } from '@/stores/useAuth.ts'

export default function DriveDeletionElement({ drive }: { drive: HeyDrive }) {
  const {profile} = useProfile()
  if (!profile || profile.username != drive.author) {
    return <div className="container mx-auto flex flex-col gap-3 justify-center items-center px-4">
      <p className='text-2xl text-center font-bold'>Speicherdauer abgelaufen</p>
      <p className='text-center'>Danke, dass du FridaySnap benutzt hast!</p>
      <p className='text-center'>Um die Speicherdauer zu verlängern und auf die Dateien zuzugreifen, bitte mit dem Admin-Link aus der E-mail einloggen.</p>
    </div>
  }
  return <div className="container mx-auto flex flex-col gap-3 justify-center items-center px-4">
    <p className='text-2xl text-center font-bold'>Speicherdauer abgelaufen</p>
    <Link to={`/d/${drive.id}/storage`}>
      <div className='btn btn-primary'>
        <IconClockPlus />
        Speicherdauer verlängern
      </div>
    </Link>
    <p className='text-center'>Danke, dass du FridaySnap benutzt hast!</p>
    <p className='text-center max-w-[30rem]'>Deine Dateien werden zum <b>{drive.will_be_deleted_at ? new Date(drive.will_be_deleted_at).toLocaleDateString() : '?'}</b> final gelöscht. Bitte verlängere deine Speicherdauer bis dahin, um auf deine Bilder zuzugreifen und sie herunterzuladen.</p>
    <Link to={`/d/${drive.id}/storage`}>
      <div className='btn btn-primary'>
        <IconClockPlus />
        Speicherdauer verlängern
      </div>
    </Link>
  </div>
}
